import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import history from 'utils/history';
import configureStore from 'ui/store/configureStore';
import App from 'ui/containers/App';
import GlobalStyle from 'styles';
import theme from 'styles/theme';
import * as serviceWorker from './serviceWorker';
import { ConfigProvider } from './context/ConfigContext';
const store = configureStore({}, history);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <ConfigProvider>
        <React.Fragment>
          <App />
          <GlobalStyle />
        </React.Fragment>
      </ConfigProvider>
    </ThemeProvider>
  </Provider>,
  document.getElementById('insent-chat-widget')
);

// enable webpack hot module replacement
// if (typeof module.hot !== 'undefined') {
//   module.hot.accept();
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
